import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomFormDrawer from '../customFormDrawer';

const useStyles = makeStyles(({ spacing }) => ({
  header: {
    padding: spacing(5, 6),
  },
  columns: {
    gridTemplateColumns: 'minmax(0, 384px) minmax(0, 1fr)',
    '& .columnContent': {
      padding: spacing(4),
    },
    '& .previewColumnContent': {
      padding: 0,
    },
    '& .scrollY': {
      right: 5,
      '& .os-scrollbar-vertical': {
        paddingTop: spacing(20),
        paddingBottom: spacing(10),
      },
    },
  },
}));

const TemplateForm = ({ translations, isOpened, columns, onSave, onClose }) => {
  const classes = useStyles();

  return (
    <CustomFormDrawer
      customHeaderClass={classes.header}
      customColumnsClass={classes.columns}
      translations={translations}
      isOpened={isOpened}
      columns={columns}
      onClose={onClose}
      onSave={onSave}
      hasCancelButton
      isFullWidth
    />
  );
};

TemplateForm.propTypes = {
  translations: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default TemplateForm;
